import React, { useEffect, useRef, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";
import { AlertTriangle, AlertCircle, Info, X } from "lucide-react";

const CFG = {
  kritik: { icon: AlertCircle, cls: "text-rose-600 bg-rose-100 dark:bg-rose-500/10 dark:text-rose-400", label: "Kritik" },
  uyari: { icon: AlertTriangle, cls: "text-amber-600 bg-amber-100 dark:bg-amber-500/10 dark:text-amber-400", label: "Uyarı" },
  bilgi: { icon: Info, cls: "text-blue-600 bg-blue-100 dark:bg-blue-500/10 dark:text-blue-400", label: "Bilgi" },
};

export default function Notifications() {
  const [notes, setNotes] = useState(null);
  const markedRef = useRef(false);

  useEffect(() => {
    api.get("/notifications").then((r) => {
      setNotes(r.data);
      if (!markedRef.current && (r.data || []).some((n) => !n.read)) {
        markedRef.current = true;
        api.post("/notifications/mark-all-read").then(() => {
          window.dispatchEvent(new Event("notifications:updated"));
        });
      }
    });
  }, []);

  const dismiss = async (n) => {
    setNotes((prev) => prev.filter((x) => x.id !== n.id));
    try {
      await api.post("/notifications/dismiss", { key: n.id });
      window.dispatchEvent(new Event("notifications:updated"));
    } catch {
      toast.error("Bildirim silinemedi");
    }
  };

  if (!notes) return <div className="text-muted-foreground">Yükleniyor...</div>;

  return (
    <div className="space-y-5 fade-in">
      <div><h1 className="font-head text-3xl font-semibold tracking-tight">Bildirim Merkezi</h1>
      <p className="text-sm text-muted-foreground mt-1">{notes.length} aktif bildirim</p></div>
      <div className="space-y-2">
        {notes.map((n) => {
          const c = CFG[n.level] || CFG.bilgi; const Icon = c.icon;
          return (
            <Card key={n.id} data-testid={`notif-${n.id}`} className="p-4 flex items-center gap-3">
              <div className={`w-9 h-9 rounded-lg grid place-items-center ${c.cls}`}><Icon size={18} /></div>
              <div className="flex-1 text-sm">{n.text}</div>
              <span className={`text-xs px-2 py-0.5 rounded ${c.cls}`}>{c.label}</span>
              <button
                data-testid={`notif-dismiss-${n.id}`}
                title="Bildirimi sil"
                onClick={() => dismiss(n)}
                className="text-muted-foreground hover:text-rose-500 p-1 rounded"
              >
                <X size={16} />
              </button>
            </Card>
          );
        })}
        {notes.length === 0 && <Card className="p-10 text-center text-muted-foreground">Bildirim yok. Her şey yolunda!</Card>}
      </div>
    </div>
  );
}
